import React, { Component } from "react";
import { Alert } from "reactstrap";
import CmsContent from "../../../../MiddleWare/CmsContent";
import Datatable from "../../../../components/Datatable/Datatable";
import { FormMiddleWare } from "../../../../components/Form";
import SingleSelect from "../../../../components/Form/SingleSelect";
import { confirmAlert } from "react-confirm-alert";
import { BoxTypescopy } from "../BoxTypescopy";

class Type10 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customerId: localStorage.getItem("userId"),
      button: this.props.button,
      boxname: "",
      boxvalue: "",
      thumbnail: "",
      traytext: "",
      portletHeading: "",
      descriptionText: "",
      newdate: ""
    };
  }

  async componentDidMount() {
    let SurveyList = await CmsContent.getTwoConditionedValue(
      "tbl_survey",
      "customerid",
      this.state.customerId,
      1,
      1,
      "id as value ,surveyname as label"
    );
    if (SurveyList) {
      this.setState({ SurveyList: SurveyList.data });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps) {
      this.setState({
        button: nextProps.button,
        boxname: nextProps.boxname,
        boxvalue: nextProps.boxvalue,
        thumbnail: nextProps.thumbnail,
        traytext: nextProps.traytext,
        portletHeading: nextProps.portletHeading,
        descriptionText: nextProps.descriptionText,
        newdate: nextProps.newdate
      });
    }
  }

  refresh = async type => {
    const formList = await CmsContent.getTwoConditionedValue(
      "tbl_form",
      "status",
      "active",
      "companyid",
      this.state.customerId,
      "id as value ,name as label"
    );
    if (formList) {
      this.setState({ formOptions: formList.data });
    }
  };

  formSelect = e => {
    this.setState({ formSelect: e });
  };

  submitCommon = async formData => {
    try {
      const result = await CmsContent.mappingportlet(
        formData,
        "tbl_boxcontent"
      );
      if (result) {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
        this.props.handler(this.state.boxvalue,this.props.alertVisible)
        // this.setState({ alertVisible: true, boxvalue: "" });
        // setTimeout(() => this.setState({ alertVisible: false }), 3000);
      }
    } catch (error) {
      console.log(error);
    }
  };

  onSubmit = async () => {


if(!this.state.boxname) 
{

this.props.errormessageboxname('errorname','Please Enter Box Name');
console.log('boxname empty')

}
else
{
 this.props.errormessageboxname('errorname',''); 

}


if(!this.state.portletHeading) 
{
 console.log('portletHeading empty')
 this.props.errormessageheading('errorheading','Please Enter Portlet Heading');

}
 
else
{
 this.props.errormessageheading('errorheading',''); 

}

if(!this.state.thumbnail) 
{
  this.props.errorthumbnail('errorthumbnail','Please Select a thumbnail');

}
 
else
{
 this.props.errorthumbnail('errorthumbnail',''); 

}




    let formData = new FormData();
    formData.append("name", this.state.boxname);
    formData.append("type", this.state.boxvalue);
    formData.append("thumbnail", this.state.thumbnail);
    formData.append("notificationtext", this.state.traytext);
    formData.append("heading", this.state.portletHeading);
    formData.append("description", this.state.descriptionText);
    formData.append("survey", this.state.selectSurveyid);
    formData.append("customerId", this.state.customerId);
    formData.append("status", "active");
    formData.append("createdAt", this.state.newdate);

  

    if(this.state.boxname &&this.state.thumbnail &&this.state.portletHeading )
     {
      console.log([...formData])
      this.submitCommon(formData);
     }

  //  this.submitCommon(formData);
  };

  addtext = async () => {




    if(!this.state.boxname) 
    {
    
    this.props.errormessageboxname('errorname','Please Enter Box Name');
    console.log('boxname empty')
    
    }
    else
    {
     this.props.errormessageboxname('errorname',''); 
    
    }
    
    
    if(!this.state.portletHeading) 
    {
     console.log('portletHeading empty')
     this.props.errormessageheading('errorheading','Please Enter Portlet Heading');
    
    }
     
    else
    {
     this.props.errormessageheading('errorheading',''); 
    
    }
    
    if(!this.state.thumbnail) 
    {
      this.props.errorthumbnail('errorthumbnail','Please Select a thumbnail');
    
    }
     
    else
    {
     this.props.errorthumbnail('errorthumbnail',''); 
    
    }
    
    
         
    let formData = new FormData();

    formData.append("name", this.state.boxname);
    formData.append("type", this.state.boxvalue);
    formData.append("thumbnail", this.state.thumbnail);
    formData.append("notificationtext", this.state.traytext);
    formData.append("heading", this.state.portletHeading);
    formData.append("description", this.state.descriptionText);
    formData.append("survey", this.state.selectSurveyid);
    formData.append("customerId", this.state.customerId);
    formData.append("status", "active");
    formData.append("createdAt", this.state.newdate);

    if(this.state.boxname &&this.state.thumbnail &&this.state.portletHeading )
    {
     console.log([...formData])
     this.submitCommon(formData);
    }
 };

  SurveyList =(e) =>{

    this.state={selectSurveyid :''}

    this.setState({ selectSurvey :e ,selectSurveyid:e.value })
   // 
  }

  render() {
    console.log(this.props)
    const { } = this.state;
 
     return (
      <React.Fragment>
        <div className="row">
          <div className="col-sm-12">
            <div className="card-body">
              <div className="row form-group">
                <div className="col-sm-2" />
                <div className="col-sm-2">
                  <label htmlFor="exampleInputEmail1">Select Survey</label>
                </div>
                <div className="col-sm-5">
                    
                  <SingleSelect
                    options={this.state.SurveyList}
                    handleChange={this.SurveyList}
                    selectedService={this.state.selectSurvey}
                  />
                </div>
                <div className="col-sm-3">
                  <button
                    type="button"
                    className="btn btn-warning"
                    onClick={() => this.refresh(this.state.boxvalue)}
                  >
                    Refresh
                  </button>
                </div>
              </div>
              <div className="row form-group">
                <div className="col-sm-4" />
                <div className="col-sm-5">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={
                      this.state.button === "Add" ? this.addtext : this.onSubmit
                    }
                  >
                    {this.state.button}
                  </button>
                </div>
                <div className="col-sm-3" />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Type10;
